import { render, staticRenderFns } from "./r-trigger-quest.vue?vue&type=template&id=2d49ded0&scoped=true"
import script from "./r-trigger-quest.vue?vue&type=script&lang=js"
export * from "./r-trigger-quest.vue?vue&type=script&lang=js"
import style0 from "./r-trigger-quest.vue?vue&type=style&index=0&id=2d49ded0&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d49ded0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d49ded0')) {
      api.createRecord('2d49ded0', component.options)
    } else {
      api.reload('2d49ded0', component.options)
    }
    module.hot.accept("./r-trigger-quest.vue?vue&type=template&id=2d49ded0&scoped=true", function () {
      api.rerender('2d49ded0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/trigger/r-trigger-quest.vue"
export default component.exports